var render = function render(){var _vm=this,_c=_vm._self._c;return _c('model-viewer',{style:(_vm.viewerStyle),attrs:{"src":_vm.src,"autoplay":"","animation-name":_vm.currentAnim,"animation-crossfade-duration":"260","camera-orbit":"0deg 82deg 100%","interaction-prompt":"none","disable-zoom":"","exposure":"1.35","shadow-intensity":"0.7"},on:{"load":_vm.onLoad}})
}
var staticRenderFns = []

export { render, staticRenderFns }